import BaseComponent    from "./BaseComponent";
import PseudoHelper     from "../Helper/Pseudo";

export default class MenuListComponent extends BaseComponent {
    constructor() {
        super();

        this._bindListener( 'click', this._onMenuExpand, 'li.menu-item.has-sub-menu' );
    }

    toggleSubmenu( el ) {
        el.find('ul.menu-item-list').first()
            .stop()
            .slideToggle({
                easing: 'linear',
                start: (p) => {
                    $(p.elem).parent('li.menu-item').toggleClass('active');
                }
            });
    }

    _onMenuExpand( event ) {
        // since our down-arrow is set to a pseudo element, we need to verify the click
        if( !PseudoHelper.isClickTarget(event, 'before') ) return;

        this.toggleSubmenu( $(event.currentTarget) );

        event.stopPropagation();
        event.preventDefault();
    }
}